export const linkCandidatesFor = (rows, linkedCarrierIds) =>
    rows.filter((row) => !row.owned && !row.isMarketplace && !linkedCarrierIds.has(row.client_id));

/** A new link's status: the carrier's compliance across the org's links, rolled up as organization_carrier_statuses does. */
const linkStatusFor = (contractorId, orgLinks) => {
    const statuses = orgLinks.reduce((contractorStatuses, link) => {
        if (link.contractor_id !== contractorId) return contractorStatuses;

        contractorStatuses.push(link.status);

        return contractorStatuses;
    }, []);

    if (statuses.includes('DENIED')) return 'DENIED';
    if (statuses.length > 0 && statuses.every((status) => status === 'APPROVED')) return 'APPROVED';

    return 'PENDING';
};

/**
 * Mutation variables to link `rows` to a Flex Center, with pay on `tariff` when one is picked. Unlinking leaves the
 * pay row behind and marketplace_idx_po allows one per carrier and Flex Center, so a relinked carrier gets its
 * leftover repriced rather than a second.
 * @param {{ rows: object[], flexCenterId: string, tariff: ?object, pricingByContractor: object, orgLinks: object[] }} args
 * @returns {{ objects: object[], pricing: object[], repricedIds: string[], repricing: object }}
 */
export const linkWritesFor = ({ rows, flexCenterId, tariff, pricingByContractor, orgLinks }) => {
    // Hasura validates _set even when no row matches, and algo_type rejects null, so no tariff means no columns.
    const repricing = tariff ? { tariff_id: tariff.tariff_id, algo_type: tariff.algo_type, enabled: true } : {};

    return rows.reduce(
        (writes, row) => {
            const status = linkStatusFor(row.client_id, orgLinks);
            writes.objects.push({ carrier_id: flexCenterId, contractor_id: row.client_id, status });
            if (!tariff) return writes;

            const leftoverPricing = pricingByContractor[row.client_id]?.[flexCenterId] || [];
            if (leftoverPricing.length) {
                const leftoverIds = leftoverPricing.map((pricing) => pricing.pricing_override_id);
                writes.repricedIds.push(...leftoverIds);
                return writes;
            }

            writes.pricing.push({
                enabled: true,
                oms: false,
                client_id: row.client_id,
                partner_client_id: flexCenterId,
                marketplace_tier: 'T1_INTEGRATIONS_ONLY',
                override_type: 'CONTRACTOR',
                tariff_id: tariff.tariff_id,
                algo_type: tariff.algo_type,
            });

            return writes;
        },
        { objects: [], pricing: [], repricedIds: [], repricing }
    );
};
